import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from '../../../shared/Link/Link';
import axios from 'axios';
import clientConfig from '../../../../config';
import { browserHistory, withRouter } from 'react-router';

const API_ROOT_URL = clientConfig.apiBaseHost + clientConfig.apiBasePath;

// import ReactGA from 'react-ga';

import { MdClose } from 'react-icons/md';
// import { browserHistory } from 'react-router';
// import './CheckoutResult.scss';

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  // 'storeid': clientConfig.storeId
};

class CheckoutSatispay extends Component {
  getPaymentDetail = async () => {
    const params = { id: this.props.params.id };
    const result = await axios({
      url: `${API_ROOT_URL}/payments/satispay/get-payment-details`,
      method: 'GET',
      headers,
      params,
    });
    return result;
  };

  componentDidMount = async () => {
    // const { checkout, advancedGa } = this.props;
    let result = await this.getPaymentDetail();
    //Se pagamento non completo ritenta il getDetail
    if (result.data.status !== 'ACCEPTED') {
      result = await this.getPaymentDetail();
    }
    //Se anche il secondo tentativo non va a buon fine avviene il redirect alla pagina failure
    if (result.data.status !== 'ACCEPTED') {
      // browserHistory.push('/checkout/checkout-failure');
      this.props.router.push('/checkout/checkout-failure');
    } else {
      //Se lo stato del pagamento è ACCEPTED avviene il redirect alla pagina success
      this.props.router.push('/checkout/checkout-success');
      // browserHistory.push('/checkout/checkout-success');
    }
  };

  render() {
    return <div>Ciao da Satispay</div>;
  }
}

const mapStateToProps = state => ({});

export default withRouter(connect(mapStateToProps)(CheckoutSatispay));
